import { createReducer, on } from '@ngrx/store';
import { UploadedIdentityCard } from '../../../../models/document.model';
import { identityCardActions } from '../identity_card.actions';

export interface CiUploadBackendState {
    doc: UploadedIdentityCard | null;
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: CiUploadBackendState = { doc: null, state: 'pending' };

export const ciUploadBackendReducer = createReducer(
    initialState,
    on(identityCardActions.uploadBackend, (state) => ({ ...state, doc: null, state: 'loading' as const })),
    on(identityCardActions.uploadBackendSuccess, (state, { payload }) => ({ ...state, doc: payload, state: 'loaded' as const })),
    on(identityCardActions.uploadBackendFail, (state) => ({ ...state, doc: null, state: 'error' as const })),
    on(identityCardActions.clearUploadBackend, () => initialState)
);
